<template>
    <div class="card card-widget">
        <!-- Add the bg color to the header using any of the bg-* classes -->
        <div class="card-footer p-0">
            <ul class="nav flex-column">
            <li class="nav-item">
                <a href="#" @click="filtrarpermisos('Super Administración')" class="nav-link">
                {{ $t('general.superadministrador') }}<span class="float-right badge bg-warning">{{totalpermisos["Super Administración"]}}</span>
                </a>
            </li>
            <li class="nav-item">
                <a href="#" @click="filtrarpermisos('Administración')" class="nav-link">
                {{ $t('general.administrador') }} <span class="float-right badge bg-info">{{totalpermisos["Administración"]}}</span>
                </a>
            </li>
            <li class="nav-item">
                <a href="#" @click="filtrarpermisos('Gestión')" class="nav-link">
                {{ $t('general.gestion') }} <span class="float-right badge bg-success">{{totalpermisos["Gestión"]}}</span>
                </a>
            </li>
            <li class="nav-item">
                <a href="#" @click="filtrarpermisos('companias')" class="nav-link">
                {{ $t('general.companias') }} <span class="float-right badge bg-danger">{{totalcompañias}}</span>
                </a>
            </li>
            <li class="nav-item">
                <a href="#" @click="filtrarpermisos('total')" class="nav-link">
                Numero de usuarios <span class="float-right badge bg-primary">{{totalusuarios}}</span>
                </a>
            </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
        props: ['totalpermisos','totalusuarios','totalcompañias'],

    data() {
        return {
            
        }
    },
    methods: {
        filtrarpermisos(permiso){
            this.$parent.usuariosporpermisos('sinevento',permiso);
            
        }
        
    },
    mounted() {
    },
    watch: {
        id() {
        }
    }
}
</script>